/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgramCoverageHistoryEntryDto
 */
export interface ProgramCoverageHistoryEntryDto {
    /**
     * 
     * @type {string}
     * @memberof ProgramCoverageHistoryEntryDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramCoverageHistoryEntryDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramCoverageHistoryEntryDto
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramCoverageHistoryEntryDto
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProgramCoverageHistoryEntryDto
     */
    snapshotDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ProgramCoverageHistoryEntryDto
     */
    coveredControls?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramCoverageHistoryEntryDto
     */
    totalControls?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramCoverageHistoryEntryDto
     */
    coveragePct?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramCoverageHistoryEntryDto
     */
    avgMaturity?: number;
    /**
     * 
     * @type {Date}
     * @memberof ProgramCoverageHistoryEntryDto
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the ProgramCoverageHistoryEntryDto interface.
 */
export function instanceOfProgramCoverageHistoryEntryDto(value: object): value is ProgramCoverageHistoryEntryDto {
    return true;
}

export function ProgramCoverageHistoryEntryDtoFromJSON(json: any): ProgramCoverageHistoryEntryDto {
    return ProgramCoverageHistoryEntryDtoFromJSONTyped(json, false);
}

export function ProgramCoverageHistoryEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramCoverageHistoryEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'snapshotDate': json['snapshotDate'] == null ? undefined : (new Date(json['snapshotDate'])),
        'coveredControls': json['coveredControls'] == null ? undefined : json['coveredControls'],
        'totalControls': json['totalControls'] == null ? undefined : json['totalControls'],
        'coveragePct': json['coveragePct'] == null ? undefined : json['coveragePct'],
        'avgMaturity': json['avgMaturity'] == null ? undefined : json['avgMaturity'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function ProgramCoverageHistoryEntryDtoToJSON(json: any): ProgramCoverageHistoryEntryDto {
    return ProgramCoverageHistoryEntryDtoToJSONTyped(json, false);
}

export function ProgramCoverageHistoryEntryDtoToJSONTyped(value?: ProgramCoverageHistoryEntryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'profileId': value['profileId'],
        'frameworkSlug': value['frameworkSlug'],
        'snapshotDate': value['snapshotDate'] == null ? undefined : ((value['snapshotDate']).toISOString().substring(0,10)),
        'coveredControls': value['coveredControls'],
        'totalControls': value['totalControls'],
        'coveragePct': value['coveragePct'],
        'avgMaturity': value['avgMaturity'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

